import React from 'react'
import { Overlay } from 'react-overlays'
import { useTranslation } from 'react-i18next'
import './styles.scss'

export default function RoomImageContextMenu ({
                                                show,
                                                target,
                                                onHide,
                                                onIncludeInPropertyGallery,
                                                onDelete,
                                                isInPropertyGallery,
                                                onEditImage,
                                              }) {
  const { t } = useTranslation()

  return (
    <Overlay
      show={show}
      target={target}
      onHide={() => {
        onHide()
      }}
      rootClose
      placement="bottom-start"
      offset={[0, 6]}
    >
      {({ props }) => (
        <div
          {...props}
          role="menu"
          className="room-image-browser-item-context-menu"
        >
          <button
            type="button"
            role="menuitem"
            className="room-image-browser-item-context-menu-item"
            onClick={onIncludeInPropertyGallery}
          >
            {
              isInPropertyGallery ? t('editRooms.imageBrowser.image.contextMenu.options.excludeFromPropertyGallery')
                : t('editRooms.imageBrowser.image.contextMenu.options.includeInPropertyGallery')
            }
          </button>
          <button
            type="button"
            role="menuitem"
            className="room-image-browser-item-context-menu-item"
            onClick={onEditImage}
          >
            {t('editRooms.imageBrowser.image.contextMenu.options.editImage')}
          </button>
          <button
            type="button"
            role="menuitem"
            className="room-image-browser-item-context-menu-item"
            onClick={onDelete}
          >
            {t('editRooms.imageBrowser.image.contextMenu.options.deleteImage')}
          </button>
        </div>
      )}
    </Overlay>
  )
}
